export default __webpack_public_path__ + "static/media/6.a4eda808.jpg";